<template>
    <div 
        class="o-units-line"
        :style="lineStyles"
    >
        <div 
            class="o-units-line__wrapper" 
        >
            <div
                :class="`o-units-line__dashed ${animation ? 'animation' : ''}`"
            />
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'
import posterLineAngle from '../../../utils/mixins/poster-line-angle'

export default {
    name: "OUnitsLine",
    inject: ['mapViewer'],
    mixins: [posterLineAngle],
    props: {
        startUnit: {
            type: [String, Number],
            require: true
        },
        finishUnit: {
            type: [String, Number],
            require: true
        },
        customStartPositons: {
            type: Boolean,
            default: false
        },
        widthCut: {
            type: Number,
            default: 0
        },
        animation: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            lineStyles: null,
            recalculateTimeout: null
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ])
    },
    methods: {
        calculatePostions() {
            const lineWidth = this.getLineWidth();
            const lineAngle = this.getAngle();

            if (lineWidth && lineAngle) {         
                this.lineStyles = {
                    width: `calc(${lineWidth}px - ${this.widthCut}vw)`,
                    transform: `rotate(${lineAngle}deg)`,
                }
            } else {
                this.lineStyles = {
                    display: 'none'
                }
                console.error(`OUnitsLine: can't get position for unit`)
            }
        },
        calculateController() {
            this.calculatePostions()
            this.recalculatePositions()
        },
        recalculatePositions() {
            clearTimeout(this.recalculateTimeout)
            this.recalculateTimeout = setTimeout(() => {
                this.calculatePostions()
            }, 100)
        }
    },
    mounted(){
        this.mapViewer.viewApi.register_event('on_camera_update', this.calculateController);
    },
    beforeDestroy(){
        this.mapViewer.viewApi.deregister_event('on_camera_update', this.calculateController);
    }
}
</script>

<style lang="scss">
@import "o-units-line";
</style>
